import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Tenants from './pages/Tenants';
import SubscriptionPlans from './pages/SubscriptionPlans';
import Invoices from './pages/Invoices';
import Profile from './pages/Profile';
import Layout from './components/Layout';
import PrivateRoute from './components/PrivateRoute';

// Clinic Portal Components
import ClinicLogin from './clinic/ClinicLogin';
import ClinicLayout from './clinic/ClinicLayout';
import ClinicDashboard from './clinic/ClinicDashboard';
import Doctors from './clinic/Doctors';
import Patients from './clinic/Patients';
import Staff from './clinic/Staff';
import Appointments from './clinic/Appointments';
import ClinicInvoices from './clinic/Invoices';
import ClinicProfile from './clinic/ClinicProfile';
import ClinicPrivateRoute from './clinic/ClinicPrivateRoute';

import './App.css';

function App() {
  return (
    <Router>
      <Toaster position="top-right" />
      <Routes>
        {/* Clinic Portal Routes - Main Login */}
        <Route path="/login" element={<ClinicLogin />} />
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route
          path="/clinic"
          element={
            <ClinicPrivateRoute>
              <ClinicLayout />
            </ClinicPrivateRoute>
          }
        >
          <Route index element={<Navigate to="/clinic/dashboard" replace />} />
          <Route path="dashboard" element={<ClinicDashboard />} />
          <Route path="doctors" element={<Doctors />} />
          <Route path="patients" element={<Patients />} />
          <Route path="staff" element={<Staff />} />
          <Route path="appointments" element={<Appointments />} />
          <Route path="invoices" element={<ClinicInvoices />} />
          <Route path="profile" element={<ClinicProfile />} />
        </Route>

        {/* Super Admin Routes */}
        <Route path="/rudra/login" element={<Login />} />
        <Route
          path="/rudra"
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route index element={<Navigate to="/rudra/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="tenants" element={<Tenants />} />
          <Route path="plans" element={<SubscriptionPlans />} />
          <Route path="invoices" element={<Invoices />} />
          <Route path="profile" element={<Profile />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
